/* eslint no-unused-vars: ['error', { 'varsIgnorePattern': 'slick' }] */
import slick from 'slick-carousel';

export default () => {

  if ($('.carousel-simple').length) {

    $('.carousel-simple-slider').slick({
      asNavFor: $('.carousel-simple-slider-captions'),
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      prevArrow: '<button class="carousel-slides-nav-prev"><span class="sr-text">Previous</span></button>',
      nextArrow: '<button class="carousel-slides-nav-next"><span class="sr-text">Next</span></button>'
    });

    $('.carousel-simple-slider-captions').slick({
      asNavFor: $('.carousel-simple-slider'),
      initialSlide: 0,
      arrows: false,
      dots: false,
      infinite: true,
      centerMode: true,
      mobileFirst: true,
      speed: 500,
      fade: true,
      slidesToShow: 1,
      slidesToScroll: 1
    });

  }

};
